<template>
  <div class="global-search">
    <div class="global-search__result">
      共为您搜索到 “{{ keyword }}” 相关的在线课程 <span>{{ originCourseList.length }}</span> 节、课件模版 <span>{{ originTemplateList.length }}</span> 个
    </div>
    <section class="global-search__block">
      <h3 class="global-search__title">线上课程</h3>
      <ul v-if="courseList.length !== 0" class="global-search__cards">
        <li v-for="course in courseList" :key="course.id" class="block__card" >
          <PromoteCard :card="course" :is-login="isLogin" />
        </li>
      </ul>
      <div v-else class="search-empty">
        <img src="/img/empty.png" alt="暂未搜索到结果" class="empty-image">
        <div class="empty-tip">没有找到相关内容，请先看看别的吧～</div>
      </div>
      <div v-show="!courseLoaded && originCourseList.length > 8" class="global-search__more" @click="loadMore('course')">加载全部 <Icon type="ios-arrow-down" /></div>
    </section>
    <section class="global-search__block">
      <h3 class="global-search__title">课件模版</h3>
      <ul v-if="templateList.length !== 0" class="global-search__cards">
        <li v-for="template in templateList" :key="template.id" class="block__card" >
          <ExpandCard :card="template" :is-login="isLogin" :is-bind-alpha="isBindAlpha" />
        </li>
      </ul>
      <div v-else class="search-empty">
        <img src="/img/empty.png" alt="暂未搜索到结果" class="empty-image">
        <div class="empty-tip">没有找到相关内容，请先看看别的吧～</div>
      </div>
      <div v-show="!templateLoaded && originTemplateList.length > 8" class="global-search__more" @click="loadMore('template')">加载全部 <Icon type="ios-arrow-down" /></div>
    </section>
    <Loading v-show="loading" tips="加载中..." />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PromoteCard from '../components/PromoteCard.vue'
import ExpandCard from '../components/ExpandCard.vue'
import api from '@/api/home.js'
import sensorHelp from '@/vendor/sensors/help'
import Loading from '@/components/ui/Loading.vue'
const MAX_CARD_NUM = 8
export default {
  name: 'globalSearch',
  components: {
    PromoteCard,
    ExpandCard,
    Loading,
  },
  data () {
    return {
      loading: false,
      keyword: '',
      courseLoaded: false,
      originCourseList: [],
      templateLoaded: false,
      originTemplateList: [],
    }
  },
  computed: {
    ...mapState('app', ['isLogin', 'isBindAlpha']),
    courseList () {
      return this.originCourseList.slice(0, this.courseLoaded ? this.originCourseList.length : MAX_CARD_NUM)
    },
    templateList () {
      return this.originTemplateList.slice(0, this.templateLoaded ? this.originTemplateList.length : MAX_CARD_NUM)
    },
  },
  watch: {
    $route (val) {
      if (val.query.keyword) {
        this.keyword = this.$route.query.keyword
      }
      this.getList()
    },
  },
  methods: {
    getList () {
      if (this.keyword) {
        sensorHelp.track('$WebClick', {
          $element_name: '线上课程_搜索',
        })
        this.loading = true
        api.globalSearch(this.keyword)().then(data => {
          this.originCourseList = data.moduleResults.course || []
          this.originTemplateList = data.moduleResults.subject || []
          document.body.scrollTo({ top: 0, behavior: 'smooth' })
        }).finally(() => {
          this.loading = false
        })
      }
    },
    loadMore (type) {
      if (type === 'course') {
        this.courseLoaded = true
      } else if (type === 'template') {
        this.templateLoaded = true
      }
    },
    // 跳转到点播详情
    goRecordDetail (obj) {
      if (obj.enable) {
        this.$router.push(`/record/detail/${obj.id}`)
      } else {
        if (this.isLogin) {
          this.$store.commit('app/setDrainagePopVisible', { flag: true, enableSign: obj.enableSign })
        } else {
          this.$Message.error('请先登录')
          this.$router.push({ name: 'Login' })
        }
      }
    },
  },
  created () {
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword
    }
    this.getList()
  },
}
</script>

<style lang="scss" scoped>
.global-search {
  width: 1200px;
  margin-inline: auto;
  &__result {
    padding: 32px 0;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    border-bottom: 1px solid #EBEBEB;
    margin-bottom: 40px;
    span {
      color: #FC7D13;
    }
  }
  &__block {
    margin-bottom: 60px;
    & + .global-search__block {
      margin-bottom: 120px;
    }
    .search-empty {
      width: 100%;
      text-align: center;
      img {
        width: 300px;
        height: 300px;
      }
      .empty-tup {
        text-align: center;
        font-size: 14px;
      }
    }
  }
  &__title {
    position: relative;
    text-indent: 12px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 26px;
    margin-bottom: 30px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: calc(50% - 1px);
      transform: translateY(-50%);
      width: 3px;
      height: 17px;
      background: #FA8919;
    }
  }
  &__cards {
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(4, 282px);
  }
  .block__card {
    /deep/ .ivu-poptip, /deep/ .ivu-poptip-rel {
      display: block;
    }
  }
  &__more {
    width: max-content;
    margin-inline: auto;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #4A4A4A;
    line-height: 16px;
    margin-top: 40px;
  }
}
</style>
